export function getFloorplans(state) {
  return state.floorplans;
}
